import React from 'react';
import { AlertTriangle, Phone, Mail, Clock, LogOut, Home, ArrowLeft } from 'lucide-react';

const TenantSuspendedPage = ({ tenantName, message }) => {
  
  const handleLogout = () => {
    // Pulisci localStorage
    localStorage.removeItem('tenant_token');
    localStorage.removeItem('tenant_refresh_token');
    localStorage.removeItem('tenant_user');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Redirect alla pagina di login tenant
    window.location.href = '/tenant';
  };

  const handleGoToLanding = () => {
    // Pulisci localStorage
    localStorage.removeItem('tenant_token');
    localStorage.removeItem('tenant_refresh_token');
    localStorage.removeItem('tenant_user');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Redirect alla landing page
    window.location.href = '/';
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 bg-cover bg-center bg-no-repeat relative"
      style={{ 
        backgroundImage: 'url(/images/login-bg.png)',
        backgroundColor: '#0f172a'
      }}
    >
      {/* Overlay scuro per leggibilità */}
      <div className="absolute inset-0 bg-slate-900/70 backdrop-blur-sm" />
      
      {/* Logo in alto a sinistra */}
      <div className="absolute -top-1 left-6 z-20">
        <img 
          src="/images/ristorantissimo-logo-text.png" 
          alt="Ristorantissimo" 
          className="h-32 md:h-40 w-auto"
        />
      </div>
      
      <div className="max-w-lg w-full relative z-10">
        {/* Card principale */}
        <div className="bg-slate-800/80 backdrop-blur-xl rounded-3xl border border-slate-700/50 shadow-2xl p-8 text-center">
          {/* Icona */}
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-amber-500/20 flex items-center justify-center">
            <AlertTriangle className="w-10 h-10 text-amber-400" />
          </div>
          
          {/* Titolo */}
          <h1 className="text-2xl font-bold text-white mb-2">
            Servizio Temporaneamente Sospeso
          </h1>
          
          {/* Nome tenant */}
          {tenantName && (
            <p className="text-slate-400 mb-4">
              {tenantName}
            </p>
          )}
          
          {/* Messaggio */}
          <div className="bg-slate-700/50 rounded-2xl p-6 mb-6">
            <p className="text-slate-300 leading-relaxed">
              {message || "Il servizio per questo account è momentaneamente sospeso. Per maggiori informazioni o per riattivare il servizio, contatta il nostro servizio clienti."}
            </p>
          </div>
          
          {/* Info contatto */}
          <div className="space-y-3 mb-6">
            <p className="text-sm text-slate-400 font-medium uppercase tracking-wide">
              Contatta il Servizio Clienti
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a 
                href="mailto:supporto@ristorantissimo.it" 
                className="flex items-center justify-center gap-2 px-4 py-3 bg-cyan-600 hover:bg-cyan-700 text-white rounded-xl transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span>supporto@ristorantissimo.it</span>
              </a>
            </div>
            
            <div className="flex items-center justify-center gap-2 text-slate-400 text-sm mt-4">
              <Clock className="w-4 h-4" />
              <span>Lun - Ven: 9:00 - 18:00</span>
            </div>
          </div>

          {/* Pulsanti per tornare indietro */}
          <div className="border-t border-slate-700/50 pt-6 space-y-3">
            <p className="text-sm text-slate-500 mb-3">Accedi con un altro account</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button 
                onClick={handleLogout}
                className="flex items-center justify-center gap-2 px-5 py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-xl transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                <span>Torna al Login</span>
              </button>
              <button 
                onClick={handleGoToLanding}
                className="flex items-center justify-center gap-2 px-5 py-3 bg-slate-600 hover:bg-slate-500 text-white rounded-xl transition-colors"
              >
                <Home className="w-4 h-4" />
                <span>Home Page</span>
              </button>
            </div>
          </div>
        </div>
        
        {/* Footer */}
        <p className="text-center text-slate-500 text-sm mt-6">
          © {new Date().getFullYear()} Ristorantissimo - Tutti i diritti riservati
        </p>
      </div>
    </div>
  );
};

export default TenantSuspendedPage;
